import { Box } from "@mui/material";
import React from "react";
import Message from "./Message/Message";

function Messages({ messages, isStreaming, queryContainerHeight, onIsolationMarkupChange, onSelectedIsolationMarkupChange }) {
  return (
    <Box>
      {messages.map((message) => (
        <Message
          key={message["query"]["message_id"]}
          message={message}
          isStreaming={isStreaming}
          queryContainerHeight={queryContainerHeight}
          isLastMessage={message === messages[messages.length - 1]}
          onIsolationMarkupChange={onIsolationMarkupChange}
          onSelectedIsolationMarkupChange={onSelectedIsolationMarkupChange}
        />
      ))}
    </Box>
  );
}

export default Messages;
